import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-card-footer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './card-footer.component.html',
  styleUrl: './card-footer.component.css',
})
export class CardFooterComponent implements OnInit {
  @Input() version: string = environment.version;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translate.use(this.translate.currentLang || 'en');
  }
}
